import { TextColors, TypographyStyles } from '@/styles'
import { Text } from '@/ui'
import { CurrencyFormatLabel } from '@/components/CurrencyFormatLabel'
import { Expense } from '@/src/actions/reportActions'

import { LineItem } from './LineItem'

const PNLSection = ({
  title,
  totalText = 'Total',
  sum,
  expenses,
  startDate,
  endDate,
  userIdForAdmin,
  isProfit,
  confirmed,
  subtitle,
}: {
  title: string
  totalText?: string
  sum: number | string
  expenses: Array<Pick<Expense, 'transactionCategoryId' | 'sum'>>
  startDate: string | undefined
  endDate: string | undefined
  userIdForAdmin: number | null
  isProfit?: boolean
  confirmed?: boolean
  subtitle?: string
}) => {
  return (
    <div className="flex flex-col gap-4 ">
      <div className="w-full flex flex-col md:flex-row justify-between">
        <div className="flex flex-col gap-2">
          <Text as={TypographyStyles.H2}>{title}</Text>
          {subtitle && (
            <Text as={TypographyStyles.BODY_SM} color={TextColors.MUTED}>
              {subtitle}
            </Text>
          )}
        </div>
        <div className="text-right">
          <Text as={TypographyStyles.H3}>
            {totalText}:{' '}
            <b>
              <CurrencyFormatLabel value={sum} />
            </b>
          </Text>
        </div>
      </div>
      {expenses.map((item) => (
        <span key={item.transactionCategoryId}>
          <LineItem
            item={item}
            startDate={startDate}
            endDate={endDate}
            userIdForAdmin={userIdForAdmin}
            isProfit={isProfit}
            confirmed={confirmed}
          />
          <div className="h-4" />
        </span>
      ))}
    </div>
  )
}

export { PNLSection }
